<template>
<div class="sidebar">
   <div class="sidebar-overlay" v-bind:class="{ 'sidebar-overlay-active': sidebarOpen }" @click="toggle" ></div>
   <div class="sidebar-menu" v-bind:class="{ 'sidebar-menu-active': sidebarOpen }">
      <slot name="sidebar" ></slot>


      <div class="row vpad yo-text-l">
            <div class="col s12 yo-align-center"><a href="https://www.biomedia.net/">home</a></div>
            <div class="col s12 yo-align-center"><a href="https://www.biomedia.net/chi-siamo/">chi siamo</a></div>
            <div class="col s12 yo-align-center"><a href="https://www.biomedia.net/eventi">calendario corsi e congressi</a></div>
            <div class="col s12 yo-align-center"><a href="https://www.biomedia.net/societa-scientifiche/">società scientifiche</a></div>
            <div class="col s12 yo-align-center"><a href="https://www.biomediashop.net/">biomedia editore</a></div>
         </div>




      <slot name="footer" v-if="false">Se non <b>passo</b> del testo</slot>
   </div>
</div>
</template>

<script>


export default {
  name: 'sidebar',
  data() {
    return {
      sidebarOpen: false
    }
  },
  created(){
    var parent = this
    this.$teras.event.on('sidebarToggle', this.toggle)
    this.$teras.event.on('sidebarClose', this.close)
    this.$teras.event.on('routerChange', this.close)
  },
  methods:{
    close(){
      this.sidebarOpen = false
    },
    toggle () {
      this.sidebarOpen = !this.sidebarOpen
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.sidebar-overlay{
  position:fixed;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  left:-100vw;
  background: #ffffff;
  opacity: 0;
  transition-duration: .4s;
}.sidebar-overlay-active{
  opacity: 0.7;
  left:0;
}.sidebar-menu{
  z-index: 1000;
  top:0;
  position:fixed;
  height: 100vh;
  width: 0;
  background:#2C95B5;
  transition-duration: .4s;
  overflow:auto;
  padding-top:40px;
}#app.device-iOS .sidebar-menu{
  padding-top:60px !important;
}.sidebar-menu .el-menu{
  border:none !important;

}.sidebar-menu-active{
  width: 280px;


}.sidebar-menu a{
  color:#fff;
  font-weight: 700;


/*

}.app-side-menu{
  padding-top:16px;
  background: transparent !important;
}.app-side-menu .el-menu-item, .app-side-menu  .el-submenu__title{
  color:#ffffff;
  font-size: 1.8rem;
  height: 46px;
  line-height: 46px;
}.app-side-menu .el-menu-item.is-active{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu-item:hover,.app-side-menu  .el-submenu__title:hover{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu li{
  color:#424F5C;
  line-height: initial;
  padding: 10px 0;
}.app-side-menu .el-submenu .el-menu li i{
  position:fixed;
  left: 15px;
  margin:2px 0 0 0;
  display:none;
}.app-side-menu .el-menu-item .material-icons, .app-side-menu .el-submenu__title  .material-icons{

  margin-right: 10px;
  vertical-align: baseline;
}.app-side-menu .el-submenu .el-menu{
  background: #b5f29f;
  color:#3E69B9 !important;
}.app-side-menu .app-side-menu .el-submenu .el-menu-item:hover,.app-side-menu .el-submenu__title:hover{
  background-color: #b5f29f !important;
  color:#3E69B9 !important;


}.app-side-menu .el-submenu .el-menu li.double{
  color:#424F5C;
  height:auto;
  
}.app-side-menu .el-submenu .el-menu li.double .more{
  font-style: italic;
  font-size:1.6rem;

  */
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue